import React from 'react';
import AU from 'country-flag-icons/react/3x2/AU';
import CA from 'country-flag-icons/react/3x2/CA';
import GB from 'country-flag-icons/react/3x2/GB';
import IN from 'country-flag-icons/react/3x2/IN';
import US from 'country-flag-icons/react/3x2/US';

const FLAG_BY_ISO = {
  us: US,
  ca: CA,
  in: IN,
  gb: GB,
  au: AU,
};

/** Colorful SVG flag (works on Windows; emoji flags often show as "US" text). */
export default function CountryFlag({ iso, className = '', title = '' }) {
  const key = String(iso || '').toLowerCase();
  const Flag = FLAG_BY_ISO[key];
  if (!Flag) return null;

  return (
    <span className={`country-flag-svg ${className}`.trim()} title={title}>
      <Flag aria-hidden />
    </span>
  );
}
